import { jsx as _jsx } from "react/jsx-runtime";
import { Section } from "@/components/UI";
import { ContactCardMobile } from "@/components/contacting";
import { useBreakpointValue } from "@gemini/core";
import { useNewBuild } from "../NewBuild";
export const ContactCard = () => {
    const isMobile = useBreakpointValue({
        base: true,
        lg: false,
    });
    const { projectLink } = useNewBuild();
    if (projectLink)
        return null;
    return (_jsx(Section, { unsafeClassname: "HideOnPrint", hideSection: !isMobile, children: _jsx(ContactCardMobile, {}) }));
};
